import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getCommuneById } from "./ServiceCommune";
import { useTranslation } from "react-i18next";
export default function DetailCommune() {
 const { t } = useTranslation();
  const { id } = useParams();

  const [data, setData] = useState({
    id: "",
    codeCommune: "",
    commune: "",
    communeArab: "",
    communeAng: "",
  });

  // Charger les donnéesa
  const loadActivityById = async () => {
    try {
      const result = await getCommuneById(id);
      setData(result.data);
      //console.log(result);
    } catch (error) {
      console.error("Erreur chargement activité :", error);
    }
  };

  useEffect(() => {
    loadActivityById();
  }, [id]);

  return (
    <div className="div-width" style={{ marginTop: "6rem" }}>
      
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">
          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>
            <Link className="mx-2" to="/"> {t("menu.home")}</Link>
          </li>

          <li className="breadcrumb-item">
            <Link className="mx-2" to="/activity-Prof">Activity Prof</Link>
          </li>

          <li className="breadcrumb-item active">Détail activité</li>
        </ol>
      </nav>

      <div className="table-container">
        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-eye fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">
          <h6 className="fs-3">Détail activité Prof</h6>

          <form>
            <div className="row justify-content-center">

              <div className="col-4">

                <div className="mb-2">
                  <label>Activity Prof</label>
                  <input className="form-control" value={data.Commune || ""} readOnly />
                </div>

                <div className="mb-2">
                  <label>activity Prof {t("common.arabic")}</label>
                  <textarea className="form-control" value={data.statutArab || ""} readOnly />
                </div>

              </div>

              <div className="col-4">

                <div className="mb-2">
                  <label>Activity ype {t("common.english")}</label>
                  <input className="form-control" value={data.statutAng || ""} readOnly />
                </div>

              </div>

              <div className="text-center mt-3">
                <Link to="/activity-Prof" className="btn btn-outline-success">
                  {t("button.close")}
                </Link>
              </div>

            </div>
          </form>

        </div>
      </div>
    </div>
  );
}